import React, { useState, useEffect } from 'react';
import { FaRss } from 'react-icons/fa';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../../firebaseConfig';
import { Link } from 'react-router-dom';

export const News = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const articlesCollection = collection(db, 'newsAndArticles');
        // Query all items ordered by creation date
        const q = query(articlesCollection, orderBy('createdAt', 'desc'));
        const querySnapshot = await getDocs(q);
        
        // Map and then filter the articles to only include 'News'
        const articlesData = querySnapshot.docs
          .map(doc => ({
            id: doc.id,
            ...doc.data(),
            date: doc.data().createdAt?.toDate().toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            }) || 'No date',
          }))
          .filter(article => article.type === 'News'); // Filter for 'News' type on the client-side

        setArticles(articlesData);
      } catch (err) {
        setError('Failed to fetch articles. Please try again later.');
        console.error("Firebase query error:", err); // Log the actual error for debugging
      } finally {
        setLoading(false);
      }
    };

    fetchArticles();
  }, []);

  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Hero Section */}
      <div className="bg-primary text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <FaRss className="text-5xl mx-auto mb-4" />
          <h1 className="text-5xl font-extrabold">News</h1>
          <p className="mt-4 text-xl">
            Stay informed with the latest news and insights from our experts.
          </p>
        </div>
      </div>

      {/* Articles Grid */}
      <div className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading && <p className="text-center">Loading articles...</p>}
          {error && <p className="text-center text-red-500">{error}</p>}
          {!loading && !error && (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {articles.map((article) => (
                <div key={article.id} className="bg-white rounded-xl shadow-lg overflow-hidden flex flex-col transition duration-300 ease-in-out transform hover:-translate-y-2">
                  {article.thumbnailUrl && (
                    <img className="h-56 w-full object-cover" src={article.thumbnailUrl} alt={article.title} />
                  )}
                  <div className="p-6 flex-grow">
                    <h2 className="text-2xl font-bold mb-3 text-gray-800">{article.title}</h2>
                    <p className="text-gray-600 mb-4 flex-grow">{article.snippet}</p>
                  </div>
                  <div className="p-6 bg-gray-50 flex justify-between items-center">
                    <p className="text-sm text-gray-500">{article.date}</p>
                    <Link to={`/content/news/${article.id}`} className="font-bold text-primary hover:text-blue-700 transition duration-300">
                      Read More &rarr;
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
